export enum WhatsAppLogEntityType {
    Unspecified = 0,
    Lab = 1,
    Radiology = 2,
    Billing = 3,
}
